import { render, staticRenderFns } from "./CodingExampleMenuBtns.vue?vue&type=template&id=9f9617f4&scoped=true&"
import script from "./CodingExampleMenuBtns.vue?vue&type=script&lang=js&"
export * from "./CodingExampleMenuBtns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f9617f4",
  null
  
)

export default component.exports